import { FC } from 'react';
import { ImageResponseType } from '../../../../../types/base';
import { Link } from 'react-router-dom';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';
import { commodityTypes } from '../../../../../data/commodityTypes';
import Status from '../../../../Status/Status';
import Favorites from '../../../../Icons/Favorites';

import styles from './Card.module.scss';

export interface ICardProps {
  article_number: string;
  commercial_number: string;
  cmmf: string;
  name: string;
  brand: {
    name: string;
    image: ImageResponseType;
  };
  category: {
    name: string;
    image: ImageResponseType;
  };
  status?: string | null;
  type: 'product' | 'part' | 'accessory';
  image: ImageResponseType;
  replaceBy?: any[] | null;
  replaceFor?: any[] | null;
  model?: string;
  isExtra?: boolean;
  id: string;
}

interface IProps {
  deleteItem: (item: ICardProps) => void;
  item: ICardProps;
}

const Card: FC<IProps> = (props) => {
  return (
    <Link
      to={'/product/' + props.item.id}
      state={{ type: props.item.isExtra ? 'accessory' : props.item.type }}
      className={styles.Card}
    >
      <div className={styles.info_holder}>
        <div>
          <img
            src={
              props.item.image?.s3Key
                ? generateImageUrl(props.item.image?.s3Key)
                : '/images/placeholderImage.png'
            }
            className={styles.image}
          />
        </div>
        <div className={styles.wrapper}>
          <h2>
            <img
              src={
                commodityTypes[props.item.type as keyof typeof commodityTypes]
                  .icon
              }
              alt={props.item.type}
            />{' '}
            {props.item.cmmf || props.item.article_number} — {props.item.name}
          </h2>
          {props.item.status && (
            <div className={styles.status_holder_mob}>
              <Status status={props.item.status} />
              <span>
                {props.item.status === 'active'
                  ? 'Активен'
                  : props.item.status === 'replacement'
                    ? 'Замена'
                    : 'Снят с производства'}
              </span>
            </div>
          )}
          <div className={styles.content_holder}>
            <div className={styles.content}>
              <span>Бренд: {props.item.brand?.name}</span>
              <span>Категория: {props.item.category?.name}</span>
              {props.item.model && <span>Модель: {props.item.model}</span>}
            </div>
            {props.item.replaceBy &&
            Array.isArray(props.item.replaceBy) &&
            props.item.type !== 'product' &&
            props.item.replaceBy.length ? (
              <>
                <div>
                  <span>
                    Замена на: {props.item.replaceBy[0]?.displayData?.partCode}
                  </span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className={styles.buttons}>
        <div className={styles.status_holder}>
          {props.item.status && <Status status={props.item.status} />}
        </div>
        <button
          className={styles.favorites_btn}
          onClick={(e) => {
            e.preventDefault();
            props.deleteItem(props.item);
          }}
        >
          <Favorites active={true} />
        </button>
      </div>
    </Link>
  );
};

export default Card;
